export default __webpack_public_path__ + "static/media/logo-sticky.a08344de.png";